import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=b8065b88&scoped=true&"
import script from "./Params.vue?vue&type=script&lang=js&"
export * from "./Params.vue?vue&type=script&lang=js&"
import style0 from "./Params.vue?vue&type=style&index=0&id=b8065b88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8065b88",
  null
  
)

export default component.exports